import type { Component } from "solid-js";
import type { IconProps } from "./types";

const WorldKnowledgeIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      {/* Globe with Continents */}
      <circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" stroke-width="1" />

      {/* Simplified Continents */}
      <path
        d="M6 4 Q7.5 3 9 4 Q10.5 3 11.5 4.5 Q12.5 3.5 12 6 Q13 6.5 12 7.5 Q12.5 8.5 11.5 9 Q10.5 10 9 8.5 Q8 9 7 8.5 Q6 9.5 5 8.5 Q5.5 7 6 4"
        fill="currentColor"
        opacity="0.2"
      />
      <path
        d="M5 10 Q5.5 11 6.5 11.5 Q7.5 12.5 8.5 12 Q9 13 10 12.5 Q10.5 13.5 12 13 Q13 14 12.5 15.5 Q11 16.5 9 15.5 Q8 16 7 15 Q6 15.5 5 14.5 Q4 14 3 13 Q3.5 11.5 5 10"
        fill="currentColor"
        opacity="0.2"
      />
      <path
        d="M10 10 Q11 9.5 12 10 Q12.5 11 13.5 10.5 Q14.5 11.5 14 13 Q13 13.5 13.5 14.5 Q12.5 15 11.5 14.5 Q11 13.5 10 13 Q9.5 11.5 10 10"
        fill="currentColor"
        opacity="0.2"
      />

      {/* Longitude line */}
      <ellipse cx="10" cy="10" rx="9" ry="4" fill="none" stroke="currentColor" stroke-width="0.5" opacity="0.5" />

      {/* Equator line */}
      <line x1="1" y1="10" x2="19" y2="10" stroke="currentColor" stroke-width="0.5" opacity="0.5" />
    </svg>
  );
};

export default WorldKnowledgeIcon;
